import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

const Keyword = ({ children, keyword = "", activeKeywords = [], ...props }) => {
  return (
    <span className={cn('keyword', {'active': activeKeywords.indexOf(keyword.toLowerCase()) !== -1})}>
      {keyword}
    </span>
  );
};

Keyword.propTypes = {
  keyword: PropTypes.string.isRequired,
  activeKeywords: PropTypes.array.isRequired,
};

export default Keyword;



// WEBPACK FOOTER //
// ./src/components/resume/Keyword.js